import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import drives from '../data/drives';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import IconSprite from './IconSprite';
import Map from './Map';
import MapUI from './MapUI';
import TabFocus from './TabFocus';
const DrivesMap = () => {
    const { ref, map, loaded: mapLoaded } = useMap();
    const { height } = useWindowSize();
    const [routes, setRoutes] = useState(null);
    // Handle map data
    useEffect(() => {
        setRoutes([
            {
                path: 'drives',
                meta: {
                    title: 'Drive times',
                    variant: 'gold',
                    layer: drives,
                },
            },
        ]);
    }, [setRoutes]);
    return (_jsxs(TabFocus, { children: [_jsx(IconSprite, {}), _jsxs("div", { className: "w-full", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && routes && _jsx(MapUI, { map: map, routes: routes })] })] }));
};
export default DrivesMap;
